import React from 'react';
import classNames from 'classnames';
import Icon, { IconName } from 'app/common/components/controls/icon';
import styles from './UpgradePromptButton.less';
import { ComponentWrapper } from 'app/src/components/ComponentWrapper';
import RouterLink from 'app/common/components/singlespa/router-link';
import { dontUpsell } from '@trello/config';

/**
 * UpgradePromptButton props
 *
 * cta: call to action of prompt, navigates user within the page
 * ctaLink: link for call to action
 * ctaOnClick: function expected to fire side-effects like a trackUe event,
 *             fired on click of cta
 * iconName: name of icon
 * isDarkTheme: controls dark theme
 */

interface UpgradePromptButtonProps {
  cta: string;
  ctaLink: string;
  ctaOnClick?: () => void;
  iconName?: IconName;
  isDarkTheme?: boolean;
  shouldFitContainer?: boolean;
  openInNewTab?: boolean;
  allowUpsell?: boolean;
}

export const UpgradePromptButton: React.FunctionComponent<UpgradePromptButtonProps> = ({
  cta,
  ctaLink,
  ctaOnClick,
  iconName,
  isDarkTheme,
  shouldFitContainer,
  openInNewTab,
  allowUpsell,
}) => {
  if (dontUpsell && !allowUpsell) {
    return null;
  }

  const onClickCTA = () => {
    if (ctaOnClick) {
      ctaOnClick();
    }
  };

  const promptClasses = classNames(
    styles.upgradePromptButton,
    isDarkTheme
      ? styles.upgradePromptButtonDarkTheme
      : styles.upgradePromptButtonLightTheme,
    shouldFitContainer && styles.upgradePromptFitContainer,
  );

  const LinkComponent = ctaLink === '/business-class' ? 'a' : RouterLink;

  return (
    <LinkComponent
      href={ctaLink}
      className={promptClasses}
      onClick={onClickCTA}
      {...(openInNewTab ? { target: '_blank' } : {})}
    >
      {iconName !== undefined && (
        <div className={styles.upgradePromptButtonIconBackground}>
          <Icon
            className={styles.upgradePromptButtonIcon}
            name={iconName}
            small={true}
          />
        </div>
      )}
      <div className={styles.upgradePromptButtonCTA}>{cta}</div>
    </LinkComponent>
  );
};

export const UpgradePromptButtonConnected: React.FunctionComponent<UpgradePromptButtonProps> = (
  props,
) => (
  <ComponentWrapper>
    <UpgradePromptButton {...props} />
  </ComponentWrapper>
);
